import { ImperativePanelHandle, Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { useSelectedAssetContext } from '@/app/assets/contexts/SelectedAssetContext';
import { Box, Group, Transition, useMantineTheme } from '@mantine/core';
import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { AssetDetailsSidebar } from '@/app/assets/details/organisms/AssetDetailsSidebar';
import styles from './details.module.css';
import { OnboardingFlows } from '../../contexts/OnboardingContext/constants';

export function AssetsLayoutWithSidebar(props: PropsWithChildren) {
  const { setSelectedAsset, selectedAsset } = useSelectedAssetContext();
  const theme = useMantineTheme();
  const sidebarRef = useRef<ImperativePanelHandle>(null);

  useEffect(() => {
    if (!selectedAsset) {
      sidebarRef.current?.collapse();
      return;
    }
    sidebarRef.current?.expand();
  }, [selectedAsset]);

  const onCollapse = () => {
    setSelectedAsset(undefined);
    sidebarRef.current?.collapse();
  };

  return (
    <Box>
      <PanelGroup direction='horizontal' style={{ overflow: 'visible' }} autoSaveId='sidebar'>
        <Panel id='page' order={1} style={{ height: 'calc(100vh - 80px)', overflowY: 'auto' }}>
          <Group className='overflow-auto' gap={0}>
            <Box flex='1 1'></Box>
            <Box w={1440} className='overflow-auto' my='md' {...{ [selectedAsset ? 'ml' : 'mx']: 'md' }}>
              {props.children}
            </Box>
            <Box flex='1 1'></Box>
          </Group>
        </Panel>
        <Transition mounted={!!selectedAsset} transition='slide-left' duration={100} timingFunction='ease' keepMounted>
          {(transitionStyle) => (
            <>
              <PanelResizeHandle className={styles.panelResize} style={{ ...transitionStyle }} />
              <Panel
                id={OnboardingFlows.SIDEBAR}
                order={2}
                className='z-10 bg-white shadow-[0_4px_10px_0_rgba(16,17,19,0.03)]'
                style={{
                  borderLeft: `1px solid ${theme.colors.gray[2]}`,
                  borderRadius: '4px 4px 0 0',
                  ...transitionStyle,
                }}
                collapsible={false}
                ref={sidebarRef}
                defaultSize={33}
                minSize={33}
                maxSize={66}
              >
                <Box className='overflow-y-auto' style={{ height: 'calc(100vh - 62px)' }}>
                  <AssetDetailsSidebar onCollapse={onCollapse} />
                </Box>
              </Panel>
            </>
          )}
        </Transition>
      </PanelGroup>
    </Box>
  );
}
